import React from 'react';
import * as HyperMD from "hypermd"

import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/mode/stex/stex";
import "codemirror/mode/yaml/yaml";
import "codemirror/addon/selection/mark-selection";

import "hypermd/powerpack/fold-math-with-katex";
import "hypermd/powerpack/hover-with-marked";

import "./App.css";

import * as ReactMarkdown from "react-markdown";

import "github-markdown-css";

import Cookies from "js-cookie";

import {Base64} from "js-base64";

import * as Y from "yjs";
import { CodemirrorBinding } from "y-codemirror";
import { WebrtcProvider } from "y-webrtc";

class Editor extends React.Component {
 constructor(props) {
  super(props);
  this.myRef = React.createRef();
 }

 getValue() {
  return this.editor.getValue();
 }

 async componentDidUpdate(previous) {
  // this.editor.setValue("foobar");
  if (previous.value !== this.props.value) {
      // console.log(this.props.value);
      this.editor.setValue(this.props.value);
      return;
      const ydoc = new Y.Doc();
      const provider = new WebrtcProvider("foobar", ydoc);
      const yText = ydoc.getText(this.props.value);
      this.binding = new CodemirrorBinding(yText, this.editor, provider.awareness);
      return;
  }   

  this.editor.setOption("readOnly", this.props.readOnly)
 }

 async componentDidMount() {
  this.editor = HyperMD.fromTextArea(this.myRef.current, {
    // for code fence highlighting
    hmdModeLoader: "https://cdn.jsdelivr.net/npm/codemirror/",
    lineNumbers: false,
    /** lineWrapping: false, **/
    foldGutter: false,
    autofocus: false,
    styleSelectedText: true,
    theme: "none",
    readOnly:  this.props.readOnly,
    cursorHeight: 0.85,  
  });

  let editor = this.editor;
  editor.setSize(null, "100%");
  // editor.display.input.blur();
  // this.editor.setValue(this.props.value);
  // console.log(this.props.value);

  // console.log(binding);

  editor.on("cursorActivity", () => {
    if (!editor.somethingSelected()) {
      this.props.onSelect(false);
      return;
    }

    let {top} = editor.cursorCoords(true, "page");
    this.props.onSelect(this.editor.getSelection(), top);
  });

  editor.on("change", (cm, {from, to, text, removed, origin}) => {
    if (origin === "setValue") {
     return;
    }
    //if (removed.join("").length > 0) {
    //  return;
    //}

    editor.markText(from, {ch: to.ch + 1, line: from.line}, {className: "inserted"});
  });
 }

 render() {
  return (
    <div className="editor">
      <div className="doc">
        <textarea style={{display: "none"}} ref={this.myRef}></textarea>
      </div>
    </div>
  );
 }
}

class Comment extends React.Component {
 render() {
  let {user: {login, avatar_url}, created_at, title, body} = this.props.comment;
  return (
    <div className="comment">
        <div className="user">
          <span className="avatar" style={{backgroundImage: `url(${avatar_url})`}}></span>
          <span className="profile">
            <div className="username">@{login}</div>
            <div className="date">{new Date(created_at).toDateString()}</div>
          </span>
        </div>
        <div className="title">{title}</div>
        <div className="body markdown-body">
          <ReactMarkdown source={body} />
        </div>
    </div>
  );
 }
}

class PostBox extends React.Component {
 constructor(props) {
  super(props);
  this.textarea = React.createRef();
  this.state = {collapsed: this.props.collapsed};
 }

  async onFocus(e) {
    // console.log(e.relatedTarget);
    if (e.relatedTarget === this.textarea.current) {
      return;
    }
    this.textarea.current.disabled = false;
    this.textarea.current.focus();
    this.setState({collapsed: false});
  }

 async onBlur(e) {
  if (e && 
      e.relatedTarget && (
      e.relatedTarget.classList.contains("issue") ||
      e.relatedTarget.classList.contains("content") ||
      e.relatedTarget.classList.contains("button") ||
      e.relatedTarget.classList.contains("compose") ||
      e.relatedTarget.classList.contains("postbox"))) {
   // TODO(goto): check for parent-child relationship;
   return;
  }

  //console.log("blurring");
  //console.log(e.relatedTarget);

  // console.log(e.relatedTarget);

  // console.log("collapsing");
  this.collapse();
 }

  collapse(e) {
    // console.log(e);
    this.textarea.current.value = "";
    this.textarea.current.disabled = false;
    this.setState({"collapsed": true});
 }

  onSubmit(e) {
    //console.log(e);
    // e.preventDefault();
  let value = this.textarea.current.value;
  // console.log(this.textarea.current);
  // console.log(this.textarea.current.value);
  this.textarea.current.disabled = true;
  this.props.onSubmit(value, this.collapse.bind(this, e));
 }

 onCancel() {
  this.textarea.current.value = "";
  this.collapse();
  this.props.onCancel();
 }

 render() {
  return (
    <div className="postbox" 
       tabIndex={this.props.index} 
       collapsed={this.props.flat ? "off" : (this.state.collapsed ? "on" : "off")}
       onFocus={this.onFocus.bind(this)} 
       onBlur={this.onBlur.bind(this)}
      >
      <textarea tabIndex={this.props.index + 1} ref={this.textarea} className="content" placeholder="Reply"></textarea>
      <div className="buttons">
        <button tabIndex={this.props.index + 2} onClick={this.onSubmit.bind(this)} className="button">{this.props.label}</button>
        <button tabIndex={this.props.index + 3} onClick={this.onCancel.bind(this)} className="secondary button">cancel</button>
      </div>
    </div>
  );
 }
}

class Issue extends React.Component {
 constructor(props) {
  super(props);
  this.state = {expanded: false, fullscreen: false, comments: []};
  this.root = React.createRef();
 }

  async onFocus(e) {
    // console.log("focusing");
    // console.log(e.relatedTarget);
    
    // this.load();
    let that = this;
    setTimeout(() => {
      if (that.state.resolved) {
        return;
      }
      that.load();
      that.setState({expanded: true})
     }, 250);
  }

 async load() {
  let {comments_url} = this.props.issue;
  if (!comments_url) {
   return;
  }

  let headers = {};

  if (this.props.isLoggedIn) {
   headers["Authorization"] = `token ${this.props.isLoggedIn}`;
  }

  let response = await fetch(comments_url, {
    headers: headers,
  });

  let comments = await response.json();

  // merges the result with the current state.

  let result = {};

  for (let comment of this.state.comments) {
   result[comment.id] = comment;
  }

  for (let comment of comments || []) {
   result[comment.id] = comment;
  }

  this.setState({comments: Object.values(result)});
 }

 async onBlur(e) {
  // console.log(e.relatedTarget);
  if (e && 
      e.relatedTarget && (
      // e.relatedTarget.classList.contains("issue") ||
      e.relatedTarget.classList.contains("content") ||
      e.relatedTarget.classList.contains("button") ||
      e.relatedTarget.classList.contains("compose") ||
      e.relatedTarget.classList.contains("postbox"))) {
   // TODO(goto): check for parent-child relationship;
   return;
  }
   //console.log("blurring");
   //console.log(e.relatedTarget.classList.contains("issue"));
   
   this.setState({expanded: false, fullscreen: false});   
 }

 async onReply(content, callback) {
   let token = this.props.isLoggedIn;
   let url = `https://api.github.com/repos/${this.props.repo}/issues/${this.props.issue.number}/comments`;
   let comment = await fetch(url, {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       "Authorization": `token ${token}`,
     },
     body: JSON.stringify({
       "body": content
     })
   });

   if (!comment.ok) {
    alert("Oops ... Something went wrong");
   }

   this.state.comments.push(await comment.json());
   // console.log(comment);
   // console.log(this.state.comments);

   callback();

   let that = this;
   this.setState({comments: this.state.comments});
   setTimeout(() => {
     // that.setState({expanded: true});
     that.root.current.focus();
     // console.log(that.root);
   }, 0);
 }

 async onCancel() {
 }

 async onClick() {
   let {html_url} = this.props.issue;
   window.open(html_url);
   this.setState({expanded: false, fullscreen: false});
 }

  async onResolve() {
    // console.log("resolving");
    this.setState({expanded: false, resolved: "progress"});
    let that = this;
    setTimeout(() => that.setState({resolved: "on"}), 1000);

    let token = this.props.isLoggedIn;
    let url = `https://api.github.com/repos/${this.props.repo}/issues/${this.props.issue.number}`;
    let issue = await fetch(url, {
      method: "PATCH",
      headers: {
	"Content-Type": "application/json",
	"Authorization": `token ${token}`,
      },
      body: JSON.stringify({
	"state": "closed"
      })
    });

    if (!issue.ok) {
      alert("Oops ... Something went wrong");
    }
  }

 async onFullScreen() {
  this.setState({fullscreen: !this.state.fullscreen});
  if (!this.state.fullscreen) {
   let y = this.root.current.getBoundingClientRect().top + window.scrollY;
   y -= 64; // header
   y -= 36; // padding
   window.scroll({
     top: y,
     behavior: "smooth"
   });
  }
 }

 render() {
   let {id} = this.props.issue;
   return (
       <div className="issue"
        ref={this.root}
        expanded={this.state.expanded ? "on" : "off"} 
        fullscreen={this.state.fullscreen ? "on" : "off"} 
        tabIndex={10 + 5*this.props.index}
        onFocus={this.onFocus.bind(this)} 
        onBlur={this.onBlur.bind(this)}
        resolved={this.state.resolved ? this.state.resolved : "off"}
        closed={this.props.issue.state}
        >
        <div className="detach" onClick={this.onFullScreen.bind(this)}></div>
        {this.props.isLoggedIn &&
          <div className="resolve" onMouseUp={this.onResolve.bind(this)}></div>
        }
        <Comment key={id} comment={this.props.issue}/>
        <div className="tail">
          <div className="comments">
            {this.state.comments.map((comment, index) => <Comment key={comment.id} comment={comment} />)}
          </div>
          {!this.props.isLoggedIn 
            ?
              <div className="signin">
                <a onClick={this.props.onSignIn}>Sign-in</a> to comment or&nbsp;
                <a onClick={this.onClick.bind(this)}>view</a> on github
              </div>
            :
              <PostBox 
                label="reply"
                index={10 + 5*this.props.index + 1}
                collapsed={"on"}
                onSubmit={this.onReply.bind(this)}
                onCancel={this.onCancel.bind(this)}
              />
          }
        </div>
      </div>
   );
 }
}

class Compose extends React.Component {
 constructor(props) {
  super(props);
  this.state = {collapsed: "off"};
  this.create = React.createRef();
 }

 write() {
  //textarea.value = "";
  // this.create.current.setAttribute("collapsed", "off");
  //console.log(textarea);
   this.setState({"collapsed": "post"});
   // debugger;   
   let textarea = this.create.current.getElementsByClassName("content")[0];
   setTimeout(() => {
     textarea.focus();
   }, 0);
  //console.log(textarea);
 }

 cancel() {
  // this.create.current.removeAttribute("collapsed");
  this.setState({"collapsed": "off"});
 }

 comment(comment, done) {
  let that = this;
  this.props.onCompose(comment, () => {
    done();
    that.setState({"collapsed": "on"});
  });
 }

 componentDidUpdate() {
  let create = this.create.current;

  if (!this.props.selection) {
   // create.removeAttribute("collapsed");
   return;
  }

  // create.setAttribute("collapsed", "on");
  create.style.top = (this.props.selection.position - 25) + "px";
 }


 async onFocus() {
  // console.log("focus");
  // this.setState({"collapsed":  "on"});
 }

  async onBlur(e) {
  if (e && 
      e.relatedTarget && (
      e.relatedTarget.classList.contains("button") ||
      e.relatedTarget.classList.contains("content") ||
      e.relatedTarget.classList.contains("compose") ||
      e.relatedTarget.classList.contains("postbox"))) {
   // TODO(goto): check for parent-child relationship;
   return;
  }

  // console.log("blurring");
  // console.log(e.relatedTarget);

  this.setState({"collapsed": "off"});
 }

 render() {
  return (
    <div 
       ref={this.create} 
       tabIndex={1}  
       onFocus={this.onFocus.bind(this)} 
       onBlur={this.onBlur.bind(this)}
       className="compose"
       selection={this.props.selection ? "on" : "off"}
       collapsed={this.state.collapsed}
      >

      <div className="compose-head" onClick={this.write.bind(this)} title="Add a comment">
        <div className="compose-head-icon"></div>
        <div className="compose-head-title">Add a comment</div>
      </div>
      <div className="compose-body">
        {this.props.user &&
          <div className="user">
            <span className="avatar" style={{backgroundImage: `url(${this.props.user.avatar_url})`}}></span>
            <span className="profile">
              <div className="username">@{this.props.user.login}</div>
              <div className="date">{new Date().toDateString()}</div>
            </span>
          </div>
        }
        <PostBox 
          label="comment" 
          flat={true}
          onSubmit={this.comment.bind(this)} 
          onCancel={this.cancel.bind(this)}
          index={2}
        />
      </div>
    </div> 
  );
 }
}

class App extends React.Component {
 constructor(props) {
  super(props);

  if (window.location.hash) {
   // console.log("hi");
   // console.log(window.location.hash.substring(1));
   window.history.replaceState({}, undefined, "/rfc/" + window.location.hash.substring(1));
  }

  var params = new URLSearchParams(window.location.search);
  if (params.get("p")) {
   // console.log("hi");
   window.history.replaceState({}, undefined, "/rfc" + params.get("p"));
  }

  let parts = window.location.pathname.split("/");
  // console.log(parts);
  parts.shift();
  parts.shift();
  //console.log(parts);
  let repo = parts.join("/");

  this.state = {
   "issues": [],
   "content": "",
   "isLoggedIn": Cookies.get("token"),
   "repo": repo,
   "committing": false
  };

  this.ids = {editor: React.createRef()};
 }

 async componentDidMount() {
  var params = new URLSearchParams(window.location.search);

  let token = this.state.isLoggedIn;

  if (token) {
   try {
     let user = await fetch("https://api.github.com/user", {
       headers: {
        "Authorization": `token ${token}`
       }
     });

     if (!user.ok) {
       throw new Error("Something went wrong");
     }

     this.setState({"user": await user.json()});
   } catch (e) {
    //console.log("error");
    //console.log(e);
    Cookies.remove("token");
     this.setState({"isLoggedIn": false});
   }

   if (this.state.user && this.state.repo) {
    let permissions = await fetch(`https://api.github.com/repos/${this.state.repo}/collaborators/${this.state.user.login}/permission`, {
      headers: {
        "Authorization": `token ${token}`
       }
    });

    if (!permissions.ok) {
     throw new Error("Something went wrong");
    }

    this.setState({"permissions": await permissions.json()});
   }

  } else if (params.has("code")) {
   let code = params.get("code");
   let gatekeeper = window.location.hostname === "localhost" ? "gatekeeper-localhost.herokuapp.com" : "rfc-gatekeeper.herokuapp.com";
   let response = await fetch(`https://${gatekeeper}/authenticate/${code}`);
   let {token} = await response.json();
   Cookies.set("token", token);
   // redirects the user.
   params.delete("code");
   let {repo} = JSON.parse(params.get("state"));
   // alert(state.hash);
   window.location = `/rfc/${repo}`;
   // window.location.search = params.toString();
  }

   this.load();
 }

  async load() {
    if (!this.state.repo) {
      return;
    }
    
  let headers = {};
  if (this.state.isLoggedIn) {
   headers["Authorization"] = `token ${this.state.isLoggedIn}`;
  }

  let issues = await fetch(`https://api.github.com/repos/${this.state.repo}/issues`, {
    headers: headers
  });
 
  if (issues.ok) {
   let result = {};

   for (let issue of this.state.issues) {
    result[issue.id] = issue;
   }

   for (let issue of await issues.json()) {
    result[issue.id] = issue;
   }

   this.setState({"issues": Object.values(result).reverse()});
  }

  let readme = await fetch(`https://api.github.com/repos/${this.state.repo}/contents/README.md`);
  let {content, sha} = await readme.json();

  if (readme.ok) {
   this.setState({"content": Base64.decode(content), "sha": sha});
  }
 }

 onSignIn() {
  let clientId = window.location.hostname === "localhost" ? "4c5232eddf335cd985b6" : "3dcc02399d8497fcce50";
  let redirectUri = window.location.hostname === "localhost" ? "http://localhost:3000/rfc" : `https://${window.location.hostname}/rfc`;
  let parts = window.location.pathname.split("/");
  // console.log(parts);
  parts.shift();
  parts.shift();
  //console.log(parts);
  let repo = parts.join("/");
  let state = JSON.stringify({repo: repo});
  window.location = `https://github.com/login/oauth/authorize?scope=read:user,public_repo&redirect_uri=${redirectUri}&client_id=${clientId}&state=${encodeURIComponent(state)}`;
 }

 onSignOut() {
   Cookies.remove("token");
   this.setState({"isLoggedIn": false, "user": undefined});  
 }

 onSelect(selection, position) {
  if (!selection) {
   this.setState({"selection": false});
   return;
  }
  this.setState({"selection": {content: selection, position: position}});
 }

 async onCompose(comment, done) {
  let lines = this.state.selection.content.split("\n");
  let quotes = lines.map((line) => `> ${line}`);
  
  let body = `${quotes.join("\n")}

${comment}
`;

  let title = comment.length < 25 ? comment : comment.substring(0, 24) + "...";

  if (!this.state.isLoggedIn) {
    window.open(`https://github.com/${this.state.repo}/issues/new?title=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}`);
    done();

    this.load();
    return;
  }

  let token = this.state.isLoggedIn;
  let issue = await fetch(`https://api.github.com/repos/${this.state.repo}/issues`, {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       "Authorization": `token ${token}`
     },
     body: JSON.stringify({
       "title": title,
       "body": body
     })
   });

   done();

   if (issue.ok) {
    this.state.issues.unshift(await issue.json());
    this.setState({"issues": this.state.issues});
   }

   this.load();
 }

 async onCommit() {
  let value = this.ids.editor.current.getValue();

  this.setState({"committing": true});

  try {
    let token = this.state.isLoggedIn;
    let commit = await fetch(`https://api.github.com/repos/${this.state.repo}/contents/README.md`, {
     method: "PUT",
     headers: {
       "Content-Type": "application/json",
       "Authorization": `token ${token}`
     },
     body: JSON.stringify({
       "content": Base64.encode(value),
       "message": ".",
       "sha": this.state.sha
     })
     });

    if (commit.ok) {
     let {content: {sha}} = await commit.json();
     this.setState({"content": value, "sha": sha});
    }

  } catch (e) {
    console.log(e);
  }
  
  this.setState({"committing": false});
 }

 async componentDidUpdate() {
 }

 render() {
  let isLoggedIn = this.state.isLoggedIn;
  let canCommit = isLoggedIn &&
  this.state.permissions && this.state.permissions.permission === "admin";
  return (
    <div className="App">
      <div className="header">
        {canCommit &&
          <button 
            className="button" 
            inprogress={this.state.committing ? "on" : "off"} 
            onClick={this.onCommit.bind(this)}>Commit</button>
        }
        {!isLoggedIn &&
           <button className="button" onClick={this.onSignIn.bind(this)}>Sign-in</button>
        }
        {(isLoggedIn && this.state.user) &&
           <span title="Sign-Out" className="profile avatar" 
             style={{
               width: "40px",
               height: "40px",
               backgroundImage: `url(${this.state.user.avatar_url})`
            }} onClick={this.onSignOut.bind(this)}></span>
        }
      </div>
      {this.state.repo &&
      <main tabIndex={0}>
        <Editor 
          ref={this.ids.editor}
          readOnly={!this.state.isLoggedIn}
          value={this.state.content} 
          onSelect={this.onSelect.bind(this)}/>
        <Compose 
          isLoggedIn={this.state.isLoggedIn}
          user={this.state.user}
          selection={this.state.selection} 
          onCompose={this.onCompose.bind(this)}
        />
        <div className="issues">
          {this.state.issues.map((issue, index) => {
              return (
                <Issue 
                  key={issue.id} 
                  repo={this.state.repo}
                  isLoggedIn={this.state.isLoggedIn} 
                  onSignIn={this.onSignIn.bind(this)}
                  issue={issue} 
                  index={index}/>
              )
            }
          )}
        </div>
      </main>
      }
    </div>
  );
 }
}

export default App;
